'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$u = require('./styles-8071793d.js');
var dimensions = require('./dimensions-5dfffb0f.js');

var TwoColumnContent = function (_a) {
    var isButtonVisible = _a.isButtonVisible, isButtonLabelVisible = _a.isButtonLabelVisible, Button = _a.Button, ButtonLabel = _a.ButtonLabel, LeftPaneContent = _a.LeftPaneContent, RightPaneContent = _a.RightPaneContent, _b = _a.isCheckoutDesktop, isCheckoutDesktop = _b === void 0 ? false : _b, _c = _a.rightColumnWidth, rightColumnWidth = _c === void 0 ? dimensions.CHECKOUT_IMAGE_WIDTH : _c, _d = _a.breakPoint, breakPoint = _d === void 0 ? dimensions.IFRAME_WIDTH : _d;
    return (React__default.createElement(styles$u.Container, { isCheckoutDesktop: isCheckoutDesktop },
        React__default.createElement(styles$u.DoublePane, { isCheckoutDesktop: isCheckoutDesktop, rightColumnWidth: rightColumnWidth, breakPoint: breakPoint },
            React__default.createElement(styles$u.LeftPane, { "data-testid": "left-pane", className: "left-pane" }, LeftPaneContent),
            React__default.createElement(styles$u.RightPane, { "data-testid": "right-pane", className: "right-pane", isCheckoutDesktop: isCheckoutDesktop, breakPoint: breakPoint }, RightPaneContent)),
        isButtonVisible && (React__default.createElement(styles$u.ButtonContainer, { className: "button-container", "data-testid": "double-pane-button", breakPoint: breakPoint, isButtonLabelVisible: isButtonLabelVisible },
            ButtonLabel,
            Button))));
};

exports.TwoColumnContent = TwoColumnContent;
